import React from "react";

import Button from "./button";

const ServiceButton = ({ isActive, to, target, title, serviceSlug, children }) => {
    
    let type="flaunt";

    if (serviceSlug && typeof serviceSlug !== "undefined")
    {
        switch (serviceSlug)
        {
            case "paid-media":
                type="paid-media";
                break;
            case "seo":
                type="seo";
                break;
            case "development":
                type="development";
                break;
            case "content-marketing":
                type="content";
                break;
            case "pr":
                type="pr";
                break;
            case "creative":
            case "creative-marketing":
                type="creative-marketing";
                break;
            case "company-updates":
                type="company-updates";
                break;
            case "resting-pitch-face":
                type="resting-pitch-face";
                break;
            default:
                type="flaunt";
                break;
        }
    } else {
        type="white";
    }

    return (
        <Button
            key={`category-button-${to}`}
            to={ to }
            target={ target }
            title={ title }
            type={ type }
            isActive={ isActive }
        >
            { children }
        </Button>
    )
}

export default ServiceButton;